module.exports = __webpack_public_path__ + "img/badge-list-thumb-004.26e91f8c.png";